import { createReducer } from '@reduxjs/toolkit'

import { toggleFullscreen, reset } from './tabs.actions'

const initialState = {}

const tabInitialConfig = {
  fullscreen: false,
}

export const tabsReducer = createReducer(initialState, {
  [toggleFullscreen.toString()]: (state, action) => {
    const { id } = action.payload

    if (state[id]) {
      state[id].fullscreen = !state[id].fullscreen
    } else {
      state[id] = {
        ...tabInitialConfig,
        fullscreen: true,
      }
    }
  },
  [reset.toString()]: () => initialState,
})
